const CONTRACT_SNAPSHOT_FIELDS = [
  'product',
  'bankName',
  'bankNumber',
  'financialInstitutionName',
  'financialInstitutionId',
  'operationStep',
  'hiringStep',
  'registrationStep',
];

export type TicketContract = {
  id?: number | string | null;
  contractId?: string | number | null;
  externalId?: number | string | null;
  product?: string | null;
  operationStep?: string | null;
  hiringStep?: string | null;
  registrationStep?: string | null;
  financialInstitutionName?: string;
  financialInstitutionId?: number;
  bankName?: string;
  bankNumber?: string;
};

export function hasAuxContractId(contract?: TicketContract): boolean {
  if (contract?.contractId == null) return false;
  return String(contract.contractId) !== String(contract?.id);
}

export function isDisplayableContract(contract?: TicketContract): boolean {
  if (contract?.id == null) return false;
  if (hasAuxContractId(contract)) return true;
  return CONTRACT_SNAPSHOT_FIELDS.some((field) => contract?.[field] != null);
}

export function displayableContractsOf(contracts?: TicketContract[]): TicketContract[] {
  return (contracts || []).filter((contract) => isDisplayableContract(contract));
}

export function contractRouteOf(contract: TicketContract) {
  const hasAuxId = hasAuxContractId(contract);
  const value = hasAuxId ? contract?.contractId : contract?.id;

  if (value == null) return null;

  return {
    url: hasAuxId ? `/backoffice/contract/${value}` : `/backoffice/contracts/${value}`,
    label: String(value),
  };
}
